import Providers from 'providers';

import Customer from './Customer';
import { CustomerGlobalStyle } from './CustomerApp.styled';

export default function App() {
  return (
    <Providers>
      <CustomerGlobalStyle />
      <Customer />
    </Providers>
  );
}
